import React, { useState } from "react";
import axios from "axios";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ReuseRecurringInvoiceButton = ({
  invoice,
  onError,
  onReused,
  size = "sm",
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!invoice?.isRecurring || invoice.deletedAt) {
    return null;
  }

  const handleReuse = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invoices/reuse/${invoice.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      onReused?.(response.data);
      navigate(`/invoice/${response.data.invoice.id}`);
    } catch (error) {
      onError?.(
        error?.response?.data?.error || "Failed to reuse recurring invoice.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline-primary"
      size={size}
      type="button"
      onClick={handleReuse}
      disabled={loading}
    >
      {loading ? (
        <>
          <Spinner as="span" animation="border" size="sm" className="me-2" />
          Reusing...
        </>
      ) : (
        "Reuse"
      )}
    </Button>
  );
};

export default ReuseRecurringInvoiceButton;
